/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AbpPtwExceptionHttpResponseModelData } from './AbpPtwExceptionHttpResponseModelData';
import {
    AbpPtwExceptionHttpResponseModelDataFromJSON,
    AbpPtwExceptionHttpResponseModelDataFromJSONTyped,
    AbpPtwExceptionHttpResponseModelDataToJSON,
} from './AbpPtwExceptionHttpResponseModelData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100MaintenanceModeException
 */
export interface Ptw100MaintenanceModeException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100MaintenanceModeException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100MaintenanceModeException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {AbpPtwExceptionHttpResponseModelData}
     * @memberof Ptw100MaintenanceModeException
     */
    data?: AbpPtwExceptionHttpResponseModelData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100MaintenanceModeException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100MaintenanceModeException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100MaintenanceModeException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100MaintenanceModeException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100MaintenanceModeException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100MaintenanceModeException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100MaintenanceModeException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {string}
     * @memberof Ptw100MaintenanceModeException
     */
    $type?: Ptw100MaintenanceModeExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100MaintenanceModeExceptionTypeEnum = {
    PtwPtw100AppZeroCoreSharedExceptionsPtw100MaintenanceModeExceptionPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100MaintenanceModeException, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type Ptw100MaintenanceModeExceptionTypeEnum = typeof Ptw100MaintenanceModeExceptionTypeEnum[keyof typeof Ptw100MaintenanceModeExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100MaintenanceModeException interface.
 */
export function instanceOfPtw100MaintenanceModeException(value?: unknown): value is Ptw100MaintenanceModeException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100MaintenanceModeExceptionTypeEnum)[0];
}

export function Ptw100MaintenanceModeExceptionFromJSON(json: any): Ptw100MaintenanceModeException {
    return Ptw100MaintenanceModeExceptionFromJSONTyped(json, false);
}

export function Ptw100MaintenanceModeExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100MaintenanceModeException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AbpPtwExceptionHttpResponseModelDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100MaintenanceModeExceptionToJSON(value?: Omit<Ptw100MaintenanceModeException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': AbpPtwExceptionHttpResponseModelDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        '$type': value['$type'],
    });
}

